import { useState, useEffect } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import ClientForm from "./ClientForm";
import InputCombo from "../../helpers/InputCombo";
import ClientReview from "./ClientReview";



function Clients(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);



    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   
        nazwa:  props.mainView.readFilter('nazwa',''),   
        nip:  props.mainView.readFilter('nip',''),   
        sl_typ_uslugi_id:  props.mainView.readFilter('sl_typ_uslugi_id',''),   

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    const [services, setServices] = useState([]);

    const [view, setView] = useState ( "list");

    const [legend, setLegend] = useState([
        {
            cls:'color_deleted',
            title: 'firma przeniesiona do archiwum',
            filter: {  filed: "archiwalne", set: "1", typ: "combo"  },
        },
    ]);


 



        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 500;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
        }


        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {

            props.mainView.writeFilter('nazwa', '');
            props.mainView.writeFilter('nip', '');
            props.mainView.writeFilter('sl_typ_uslugi_id', '');
           

            setFilterParam({
                nazwa: '',                 
                nip: '',                 
                sl_typ_uslugi_id: '',                 
                
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }



        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }




    const getTab = () => {
        

        props.mainView.showProgress();       
 

        fetch( Config.url + '/rest_v1_home,clients', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                props.mainView.hideProgress();    

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();    
         });
                   

         return false;
    }




        const getTServices = () => {
        
   
        props.mainView.showProgress();    

        fetch( Config.url + '/rest_v1_home,t_services', {
            method: 'POST', 
            body: JSON.stringify({all:1}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();    
                 

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setServices(res.result);                                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();    
         });
                   

         return false;
    }



    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');
            setView({...view, ["v"]:v, ["id"]:id });
    }

  


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });               
    }

   
   const onSuccess = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }

    



   const keyListener = (e) => {
                       var code = e.keyCode ? e.keyCode : e.which;    

                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                                e.target.blur();
                                filterClear();
                        }else                            
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                                filterClear();
                        }else                                                                     
                        if( e.target.nodeName.toLowerCase() == "body" && code === 37 && filterParam.page > 1)  //left
                        {
                                setFilterParam( {...filterParam,   ['page']: filterParam.page-1  } );  
                                setTab(null);
                        }else                                             
                        if(e.target.nodeName.toLowerCase() == "body" && code === 39 && filterParam.page < filterParam.pages)  //right
                        {
                                setFilterParam( {...filterParam,   ['page']: filterParam.page+1  } );  
                                setTab(null);
                        }else                                              
                        if (e.target.nodeName.toLowerCase() == "body" && code === 107) { //add +
                            setView({...view, ["v"]:'new', ["id"]:'-1' });
                        }else 
                        {
                            props.keyListener(e);
                        }
   }

   useEffect( ()=>{

            if(Config.env == "dev") console.log("Clients.js, listener on");
            window.onkeydown = keyListener; 

            return () => {   
                 if(Config.env == "dev") console.log("Clients.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );








    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        setTab(null);
        getTServices();
    }



    if(tab == null)
    {
        setTab([]);
        getTab();    
        getTServices(); 
        return <div>
            ...
        </div>
    }


    document.title = "Baza klientów";


    if(view.v == "review")
    {
        return <ClientReview  userData={props.userData} mainView={props.mainView}  keyListener={keyListener}  onBack={onBack}  onSuccess={onSuccess}   id={view.id} />
    }


    if(view.v == "edit")
    {
        return <ClientForm  userData={props.userData} mainView={props.mainView} onBack={onBack}   keyListener={keyListener}   onSuccess={onSuccess}   id={view.id} />
    }

    if(view.v == "new")
    {
        return <ClientForm  userData={props.userData} mainView={props.mainView} onBack={onBack}   keyListener={keyListener}   onSuccess={onSuccess}  id={-1} />
    }
    

 
        var sortList = [                
        {column: "created_at", name: "Data utworzenia"  },         
        {column: "firma_nazwa", name: "Nazwa firmy"  },
]



    return  <div className="view_content">

            

                <h3 className="dash_header">Baza klientów</h3>

    
               <div className="table_filter">

                        <div className="filter_controll">   
                                <label>NIP: </label>                             
                                <InputText   userData={props.userData} value={filterParam.nip}   valChange={valChangeListener} goNext={goNextNew} name="nip" placeholder={"NIP: "}   />
                        </div> 

                        <div className="filter_controll">   
                                <label>Nazwa: </label>                             
                                <InputText   userData={props.userData} value={filterParam.nazwa}   valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: "}   />
                        </div> 

                        <div className="filter_controll">   
                                <label>Typ klienta: </label>                             
                                <InputCombo items={services}   userData={props.userData} value={filterParam.sl_typ_uslugi_id}   valChange={valChangeListener} goNext={goNextNew} name="sl_typ_uslugi_id" placeholder={": "}   />
                        </div> 


                      


                        <div className="filter_btn">                       
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść [esc]</span>
                        </div> 
               </div>




                <div className="table_widget">
                              <div className="btn" onClick={changeView} v="new" id="-1"  > dodaj klienta [+]</div>

                              &nbsp;&nbsp;
 

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                
                              <InputLegend items={legend}  valChange={valChangeListener} />

                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                </div>


               <div className="bg_center">

                        <table className="table"  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>
                                                <td>NIP</td>                                                                                                                                    
                                                <td>Nazwa</td>                                                                                                                                    
                                                <td className="td_right">Adres</td>                                                                                      
                                                <td className="td_option"></td>                                                                                  
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            return <tr className={rowStyle} key={ix}>
                                                                <td>{ix+1}</td>
                                                                <td className="gocenter" v="review" id={row.id} onClick={changeView} >{row.nip}</td>
                                                                <td v="review" id={row.id} onClick={changeView}>{row.nazwa}</td>
                                                                <td>{row.zm_ulica} {row.zm_miejscowosc}</td>
                                                                <MenuTable>
                                                                    <ul>
                                                                        <li v="review" id={row.id} onClick={changeView} >Podgląd</li>
                                                                        <li v="edit" id={row.id} onClick={changeView}>Zmień dane</li>
                                                                    </ul>
                                                                </MenuTable>
                                                     
                                                            </tr>

                                                    } )
                                                }

                                        </tbody>

                                </table>

               </div>
 
              

                              
 

    </div>
}


export default Clients;